var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"title":_vm.$t('_.version_history'),"cancel-text":"_.close"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('terms-and-conditions-revisions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }